import { render, staticRenderFns } from "./TripleAccessSection.vue?vue&type=template&id=90268db6&scoped=true"
import script from "./TripleAccessSection.vue?vue&type=script&lang=js"
export * from "./TripleAccessSection.vue?vue&type=script&lang=js"
import style0 from "./TripleAccessSection.vue?vue&type=style&index=0&id=90268db6&prod&lang=scss&scoped=true"
import style1 from "./TripleAccessSection.vue?vue&type=style&index=1&id=90268db6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90268db6",
  null
  
)

export default component.exports